/* eslint-disable max-len */
export default {
  country: "País",
  "state/city": "Estado/ciudad",
  address: "Dirección",
  "consultation-value": "Valor de la consulta",
  "consultation-value-simple": "Valor consulta",
  follow: "Seguir",
  followed: "Siguiendo",
  "see-complete-profile": "Ver el perfil completo",
  consultation: "Consultorio",
  "return-home": "Regresar",
  meet: "Atiende",
  "consultation-type-inperson": "Presencial",
  "consultation-type-online": "Online",
  "schedule-appointment": "Agenda de cita",
  "appointment-question": "¿La consulta médica es para ti?",
  "first-name": "Primer nombre",
  "name-placeholder": "Ingresa el nombre",
  "first-surname": "Primer apellido",
  "surname-placeholder": "Ingresa el apellido",
  gender: "Género",
  "gender-placeholder": "Ingresa el género",
  "birth-date": "Fecha de nacimiento",
  "birth-date-placeholder": "Ingresa la fecha de nacimiento",
  email: "Correo electrónico",
  "email-placeholder": "Ingresa el correo",
  "country-code": "Código",
  "phone-number": "Número",
  "phone-number-placeholder": "304 632 7544",
  "bond-with-the-patient": "Vínculo con el paciente",
  "bond-with-the-patient-placeholder": "Relación que tienes con el paciente",
  "reason-for-consultation": "Motivo de la consulta",
  "leave-your-message": "Deja tu mensaje",
  "leave-your-message-placeholder": "Describe brevemente el motivo por el cual deseas agendar tu consulta.",
  "payment-method": "Método de pago",
  "payment-method-placeholder": "Selecciona método de pago",
  yes: "Sí",
  no: "No",
  "schedule-appointment-modal": "Agendar cita",
  "patient-name": "Nombre del paciente",
  "year-of-birth": "Año de nacimiento",
  age: "Edad",
  "scheduled-with": "Estás agendado tu cita con",
  "appointment-email": "Recibirás un correo electrónico con toda la información de tu cita médica.",
  "consultation-type": "Tipo de consulta",
  confirm: "Confirmar",
  "go-back": "Regresar",
  "consultation-price": "Precio por consulta",
  "first-consultation": "Consulta inicial",
  "second-consultation": "Consulta de seguimiento",
  "selected-consultory": "Consultorio",
  "select-appointment-type": "Tipo de consulta",
  online: "Online",
  "in-person": "Presencial",
  "office-schedule": "Consultorio y horario",
  "appointment-data": "Datos de la cita",
  processing: "Procesando",
  "field-required": "Campo requerido",
  "service-error": "Error en servicio",
  "please-try-again-later": "Por favor, intente de nuevo mas tarde",
  "invalid-characters": "Caracteres inválidos",
  "invalid-email": "Correo electrónico inválido",
  "configuration-not-found": "Este doctor no tiene consultas abiertas actualmente",
  "appointment-confirmation": "Gracias por agendar tu cita con Dr. Now",
  "appointment-confirmation-description": "Recibirás un correo electrónico con todo el detalle de tu próxima consulta médica. Recuerda que los mejores médicos del país los encuentras en Dr.Now.",
  "appointment-confirmation-description-2": "¡Nos vemos pronto!",
  "appointment-confirmation-button-forward": "Ir al inicio",
  "appointment-confirmation-button-backward": "Regresar",
  "complete-profile": "Ver perfil completo",
  "complete-profile-short": "Ver perfil",
  "register-now": "¿Aún no tienes tu cuenta? Regístrate ahora",
  register: "Registrarme",
  "log-in": "Iniciar sesión",
  years: "años",
  day: "Día",
  hour: "Hora",
  "valid-country-code": "Ingrese un código de país válido",
  january: "Enero",
  february: "Febrero",
  march: "Marzo",
  april: "Abril",
  may: "Mayo",
  june: "Junio",
  july: "Julio",
  august: "Agosto",
  september: "Septiembre",
  october: "Octubre",
  november: "Noviembre",
  december: "Diciembre",
  monday: "dom",
  tuesday: "lun",
  wednesday: "mar",
  thursday: "mié",
  friday: "jue",
  saturday: "vie",
  sunday: "sáb",
};
